export default "__VITE_ASSET__DN_sOxYY__"